(function(){"use strict";try{var s=document.createElement("style");s.appendChild(document.createTextNode('@charset "UTF-8";table.sns,table.sns *{box-sizing:border-box}table.sns tbody:first-child tr:not(:first-child) th,table.sns tbody:first-child tr:not(:first-child) td{border-top-width:0}table.sns thead *[class*=sns--is-stuck],table.sns tbody *[class*=sns--is-stuck]{position:relative;transition:box-shadow .1s}table.sns thead *[class*=sns--is-stuck]:empty:after,table.sns tbody *[class*=sns--is-stuck]:empty:after{content:"\\200b"}table.sns thead *[class*=sns--is-stuck]:not(.sns__placeholder-cell) b,table.sns tbody *[class*=sns--is-stuck]:not(.sns__placeholder-cell) b{position:relative;z-index:1}table.sns thead *[class*=sns--is-stuck]:not(.sns__placeholder-cell):before,table.sns tbody *[class*=sns--is-stuck]:not(.sns__placeholder-cell):before{content:"";position:absolute;border:inherit;top:0;right:0;bottom:0;left:0;margin:inherit;transition:box-shadow .1s;box-shadow:var(--x-shadow, 0),var(--y-shadow, 0);z-index:0}table.sns thead *[class*=sns--is-stuck] .sns__placeholder-cell,table.sns tbody *[class*=sns--is-stuck] .sns__placeholder-cell{position:relative}table.sns thead *[class*=sns--is-stuck] .sns__cell-inner,table.sns tbody *[class*=sns--is-stuck] .sns__cell-inner{position:relative;height:inherit}table.sns thead *[class*=sns--is-stuck]>*,table.sns tbody *[class*=sns--is-stuck]>*{position:relative;z-index:1}table.sns thead *.sns--is-stuck,table.sns tbody *.sns--is-stuck{z-index:100;will-change:transform;transform:translate(var(--sns-scroll-left),var(--sns-scroll-top))}table.sns thead *.sns--is-stuck-x,table.sns tbody *.sns--is-stuck-x{z-index:80;will-change:transform;transform:translate(var(--sns-scroll-left))}table.sns thead *.sns--is-stuck-y,table.sns tbody *.sns--is-stuck-y{z-index:90;will-change:transform;transform:translateY(var(--sns-scroll-top))}@media screen and (-ms-high-contrast: active),(-ms-high-contrast: none){table.sns{margin-top:-2px;margin-left:-1px}}')),document.head.appendChild(s)}catch(t){console.error("vite-plugin-css-injected-by-js",t)}})();
function j(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var I = { exports: {} }, P = !1, d, g, T, w, x, W, v, A, D, F, C, L, N, Y, U;
function l() {
  if (!P) {
    P = !0;
    var e = navigator.userAgent, t = /(?:MSIE.(\d+\.\d+))|(?:(?:Firefox|GranParadiso|Iceweasel).(\d+\.\d+))|(?:Opera(?:.+Version.|.)(\d+\.\d+))|(?:AppleWebKit.(\d+(?:\.\d+)?))|(?:Trident\/\d+\.\d+.*rv:(\d+\.\d+))/.exec(e), r = /(Mac OS X)|(Windows)|(Linux)/.exec(e);
    if (L = /\b(iPhone|iP[ao]d)/.exec(e), N = /\b(iP[ao]d)/.exec(e), F = /Android/i.exec(e), Y = /FBAN\/\w+;/i.exec(e), U = /Mobile/i.exec(e), C = !!/Win64/.exec(e), t) {
      d = t[1] ? parseFloat(t[1]) : t[5] ? parseFloat(t[5]) : NaN, d && document && document.documentMode && (d = document.documentMode);
      var n = /(?:Trident\/(\d+.\d+))/.exec(e);
      W = n ? parseFloat(n[1]) + 4 : d, g = t[2] ? parseFloat(t[2]) : NaN, T = t[3] ? parseFloat(t[3]) : NaN, w = t[4] ? parseFloat(t[4]) : NaN, w ? (t = /(?:Chrome\/(\d+\.\d+))/.exec(e), x = t && t[1] ? parseFloat(t[1]) : NaN) : x = NaN;
    } else
      d = g = T = x = w = NaN;
    if (r) {
      if (r[1]) {
        var s = /(?:Mac OS X (\d+(?:[._]\d+)?))/.exec(e);
        v = s ? parseFloat(s[1].replace("_", ".")) : !0;
      } else
        v = !1;
      A = !!r[2], D = !!r[3];
    } else
      v = A = D = !1;
  }
}
var M = {
  ie: function() {
    return l() || d;
  },
  ieCompatibilityMode: function() {
    return l() || W > d;
  },
  ie64: function() {
    return M.ie() && C;
  },
  firefox: function() {
    return l() || g;
  },
  opera: function() {
    return l() || T;
  },
  webkit: function() {
    return l() || w;
  },
  safari: function() {
    return M.webkit();
  },
  chrome: function() {
    return l() || x;
  },
  windows: function() {
    return l() || A;
  },
  osx: function() {
    return l() || v;
  },
  linux: function() {
    return l() || D;
  },
  iphone: function() {
    return l() || L;
  },
  mobile: function() {
    return l() || L || N || F || U;
  },
  nativeApp: function() {
    return l() || Y;
  },
  android: function() {
    return l() || F;
  },
  ipad: function() {
    return l() || N;
  }
}, q = M, E = !!(typeof window < "u" && window.document && window.document.createElement), V = {
  canUseDOM: E,
  canUseWorkers: typeof Worker < "u",
  canUseEventListeners: E && !!(window.addEventListener || window.attachEvent),
  canUseViewport: E && !!window.screen,
  isInWorker: !E
}, K = V, b = K, H;
b.canUseDOM && (H = document.implementation && document.implementation.hasFeature && document.implementation.hasFeature("", "") !== !0);
/**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @param {?boolean} capture Check if the capture phase is supported.
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */
function Z(e, t) {
  if (!b.canUseDOM || t && !("addEventListener" in document))
    return !1;
  var r = "on" + e, n = r in document;
  if (!n) {
    var s = document.createElement("div");
    s.setAttribute(r, "return;"), n = typeof s[r] == "function";
  }
  return !n && H && e === "wheel" && (n = document.implementation.hasFeature("Events.wheel", "3.0")), n;
}
var J = Z, Q = q, ee = J, $ = 10, S = 40, O = 800;
function z(e) {
  var t = 0, r = 0, n = 0, s = 0;
  return "detail" in e && (r = e.detail), "wheelDelta" in e && (r = -e.wheelDelta / 120), "wheelDeltaY" in e && (r = -e.wheelDeltaY / 120), "wheelDeltaX" in e && (t = -e.wheelDeltaX / 120), "axis" in e && e.axis === e.HORIZONTAL_AXIS && (t = r, r = 0), n = t * $, s = r * $, "deltaY" in e && (s = e.deltaY), "deltaX" in e && (n = e.deltaX), (n || s) && e.deltaMode && (e.deltaMode == 1 ? (n *= S, s *= S) : (n *= O, s *= O)), n && !t && (t = n < 1 ? -1 : 1), s && !r && (r = s < 1 ? -1 : 1), {
    spinX: t,
    spinY: r,
    pixelX: n,
    pixelY: s
  };
}
z.getEventType = function() {
  return Q.firefox() ? "DOMMouseScroll" : ee("wheel") ? "wheel" : "mousewheel";
};
var te = z;
(function(e) {
  e.exports = te;
})(I);
const re = /* @__PURE__ */ j(I.exports);
const k = /* @__PURE__ */ new WeakMap();
function B(e, t = 0, r = 0) {
  e.parentElement.style.setProperty("--sns-scroll-left", `${t}px`), e.parentElement.style.setProperty("--sns-scroll-top", `${r}px`);
}
function ne(e, t, r) {
  oe(e, t, r);
}
function oe(e, t, r) {
  B(e, t.scrollLeft, t.scrollTop), r && r(t.scrollLeft, t.scrollTop);
}
function X({
  cell: e,
  isFirefox: t,
  scrollPositions: { left: r, top: n },
  showShadow: s
}) {
  if (!e)
    return;
  const m = window.getComputedStyle(e);
  ["Top", "Right", "Bottom", "Left"].forEach((a) => {
    ["Width"].forEach((c) => {
      let f = m[`border${a}${c}`];
      if (t) {
        const h = f.match(/([^a-z%]+)([a-z%]+)/);
        f = `${Math.round(h[1])}${h[2]}`;
      }
      e.style[`margin${a}`] = `-${f}`;
    });
  });
}
function ie(e, t = {}) {
  const { showShadow: r, callback: n } = t, m = navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
  typeof e.toArray == "function" ? e = e.toArray() : Array.isArray(e) || (e = [e]), e.forEach((a) => {
    if (!k.get(a)) {
      let h = function(o) {
        const i = o.currentTarget, u = re(o);
        i.scrollTo(
          i.scrollLeft + u.pixelX,
          i.scrollTop + u.pixelY
        ), o.preventDefault(), f = !0, requestAnimationFrame(() => {
          i.style.setProperty(
            "--sns-scroll-left",
            `${i.scrollLeft}px`
          ), i.style.setProperty("--sns-scroll-top", `${i.scrollTop}px`), n && n(i.scrollX, i.scrollY);
        });
      }, R = function() {
        f ? f = !1 : ne(a, c, n);
      };
      const c = a.parentElement;
      let f = !1;
      c.addEventListener("wheel", h, { capture: !0 }), c.addEventListener("scroll", R);
      const p = [
        "sns--is-stuck",
        "sns--is-stuck-y",
        "sns--is-stuck-x"
      ].reduce((o, i) => (o.push(a.getElementsByClassName(i)), o), []);
      getComputedStyle(c).position === "static" && (c.style.position = "relative"), a.classList.add("sns"), a.style.position = "relative", ["Top", "Left"].forEach((o) => {
        a[`offset${o}`] > 0 && (a.style[o.toLowerCase()] = `-${a[`offset${o}`]}px`);
      });
      const y = {
        left: c.scrollLeft || 0,
        top: c.scrollTop || 0
      };
      k.set(a, y);
      for (let o = 0; o < p.length; o++)
        for (let i = 0; i < p[o].length; i++) {
          const u = p[o][i];
          X({
            cell: u,
            isFirefox: m,
            scrollPositions: y,
            showShadow: r
          });
        }
      new MutationObserver((o) => {
        o.forEach((i) => {
          if (!!/^THEAD|TBODY|TFOOT|TH|TD$/.test(i.target.nodeName))
            for (let u = 0; u < p.length; u++)
              for (let _ = 0; _ < p[u].length; _++) {
                const G = p[u][_];
                X({
                  cell: G,
                  isFirefox: m,
                  scrollPositions: y,
                  showShadow: r
                });
              }
        });
      }).observe(c, {
        childList: !0,
        subtree: !0,
        attributes: !0,
        attributeFilter: ["class"]
      }), requestAnimationFrame(() => {
        B(a, c.scrollLeft, c.scrollTop);
      });
    }
  });
}
export {
  ie as default
};
